export default [
    { key: 'code', label: 'ID', sortable: false },
    { key: 'name', label: 'Nombre' },
    { key: 'assignee.name', label: 'Responsable' },
    { key: 'created_by.name', label: 'Creador' },
    { key: 'description', label: 'Descripción' },
    { key: 'created_at', label: 'Fecha creación' },
    { key: 'due_date', label: 'Fecha vencimiento' },
    { key: 'notes', label: 'Notas', sortable: false },
    { key: 'files', label: 'Archivos', sortable: false },
    { key: 'actions', label: 'Acciones' },
]